import { useMemo } from 'preact/hooks'
import { FilterCollapse } from './FilterCollapse'
import { FilterInputCheckbox } from './FilterInputCheckbox'
import { FilterInputTabs } from './FilterInputTabs'
import { FilterInputSlider } from './FilterInputSlider'
import { FilterInputSizing } from './FilterInputSizing'
import { RANGE_INDICATOR } from './FilterUtils'

export function FilterItem({ filter, activeFilters, fetchedFilters, onFilter, removeAll }) {
  if (!filter) return null

  const fetchedFilter = useMemo(() => {
    return fetchedFilters.find((current) => current.field === filter.field)
  }, [fetchedFilters])

  const values = useMemo(() => {
    return (
      filter.values.map((item) => {
        // TODO: range delimiter here should be provided somewhere else
        const value = item.type === 'slider' ? `${item.low}${RANGE_INDICATOR}${item.high}` : item.value
        const valueWithKey = `${filter.field}:${value}`

        const fetchedValue = fetchedFilter?.values?.find((currentValue) => {
          return currentValue.label === item.label
        })

        return {
          label: item.label,
          value: valueWithKey,
          count: fetchedValue?.count,
          checked: activeFilters.has(valueWithKey),
          disabled: !fetchedValue
        }
      }) ?? []
    )
  }, [filter, activeFilters, fetchedFilter])

  if (!values.length === 0) return null

  return (
    <FilterCollapse label={filter.label}>
      <div
        className={`${
          filter.label !== 'Size' && filter.label !== 'Gender' && filter.type !== 'slider' ? 'flex flex-wrap' : ''
        } py-2`}
      >
        {filter.type === 'slider' ? (
          <FilterInputSlider filter={filter} values={values} onFilter={onFilter} />
        ) : filter.label === 'Gender' ? (
          <FilterInputTabs name={filter.field} values={values} onFilter={onFilter} removeAll={removeAll} />
        ) : (
          <FilterInputCheckbox
            name={filter.field}
            values={values}
            onFilter={onFilter}
            split={filter.label !== 'Brand'}
          />
        )}
      </div>
    </FilterCollapse>
  )
}

export function FilterSizeItem({ initialFilters, activeFilters, fetchedFilters, onFilter }) {
  if (!initialFilters) return null
  return (
    <FilterCollapse label={'Size'}>
      <div className={'py-2'}>
        <FilterInputSizing
          initialFilters={initialFilters}
          fetchedFilters={fetchedFilters}
          activeFilters={activeFilters}
          onFilter={onFilter}
        />
      </div>
    </FilterCollapse>
  )
}
